export interface TokenPatch {
    type_id: TokenTypeId;
    status?: TokenStatus;
    block_reason?: TokenBlockReason;
    expiration_at?: string;
    digicode?: DigicodePatch;
    prospect_digicode?: DigicodePatch;
}

export interface DigicodePatch {
    username?: string;
    password?: string;
}

export enum TokenTypeId {
    DIGIPAS = 'digipas',
    DIGICODE = 'digicode',
    PROSPECT_DIGICODE = 'prospect_digicode',
    MOBILE_DEVICE_LOW = 'mobile_device_low',
    MOBILE_DEVICE = 'mobile_device',
    MOBILE_FINGERPRINT_LOW = 'mobile_fingerprint_low',
    MOBILE_FINGERPRINT = 'mobile_fingerprint',
    MOBILE_FACE_LOW = 'mobile_face_low',
    MOBILE_FACE = 'mobile_face',
    MOBILE_PIN_LOW = 'mobile_pin_low',
    MOBILE_PIN = 'mobile_pin',
    MOBILE_BIOMETRIC = 'mobile_biometric',
    MOBILE_BIOMETRIC_LOW = 'mobile_biometric_low',
    BROWSER_DEVICE = 'browser_device',
    BROWSER_PINCODE = 'browser_pin'
}

export interface DevicePatch {
    status?: DeviceStatus;
    user_fullname?: string;
    user?: Party;
}

export enum DeviceStatus {
    ACTIVE = 'active',
    BLOCKED = 'blocked',
    EXPIRED = 'expired',
    REMOVED = 'removed'
}

export enum TokenStatus {
    ACTIVE = 'active',
    BLOCKED = 'blocked',
    EXPIRED = 'expired',
    REMOVED = 'removed'
}

export enum TokenBlockReason {
    BLOCKED_BY_CUSTOMER_SERVICE = 'blocked_by_customer_service',
    TOO_MANY_CONSECUTIVE_LOGIN_FAILURES = 'too_many_consecutive_login_failures'
}

export interface Party {
    id?: string;
    type?: PartyType;
    eb_contract_id?: string;
}

export enum PartyType {
    CUSTOMER = 'customer',
    EMPLOYEE = 'employee',
    PROSPECT = 'prospect',
    ANONYMOUS = 'anonymous'
}
